import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { CookieManagerOption } from './cookie-manager-option';

import I18n from '@app/modules/i18n';
import Privacy from '@app/modules/privacy';
import Button from '@component/form/element/button';

const CookieManagerSettings = ({
  savedTrackingSettings,
  notified,
  updateFormState,
}) => {
  const [trackingSettings, setTrackingSettings] = useState(undefined);
  // if user interacted with the form, the value will be a boolean
  const trackingSettingsChanged = trackingSettings !== undefined;
  const handleSelect = ({ target }) => setTrackingSettings(target.checked);

  // handle navigating away with unsaved changes
  React.useEffect(() => {
    updateFormState(trackingSettingsChanged);
  }, [updateFormState, trackingSettingsChanged]);

  // reset the form state to false when unmounting
  React.useEffect(() => {
    return function cleanup() {
      updateFormState(false);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (trackingSettings === true) {
      Privacy.acceptTrackers();
    } else if (trackingSettings === false) {
      Privacy.declineTrackers();
    }

    location.reload();
  };

  return notified ? (
    <form className="cookie-manager-settings" onSubmit={handleSubmit}>
      <ul className="cookie-manager-settings__list">
        <CookieManagerOption
          handleSelect={handleSelect}
          title={I18n.t('transfer.cookie-manager.functional.title')}
          description={I18n.t('transfer.cookie-manager.functional.description')}
          id="functional"
          disabled={true}
          checked={true}
        />
        <CookieManagerOption
          handleSelect={handleSelect}
          title={I18n.t('transfer.cookie-manager.analytical.title')}
          description={I18n.t('transfer.cookie-manager.analytical.description')}
          id="analytical"
          disabled={true}
          checked={true}
        />
        <CookieManagerOption
          handleSelect={handleSelect}
          title={I18n.t('transfer.cookie-manager.tracking.title')}
          description={I18n.t('transfer.cookie-manager.tracking.description')}
          id={'tracking'}
          disabled={false}
          checked={
            trackingSettingsChanged ? trackingSettings : savedTrackingSettings
          }
        />
      </ul>
      <Button
        submit
        text={I18n.t('transfer.cookie-manager.save-and-reload')}
        className="cookie-manager-settings__submit "
        active={trackingSettingsChanged}
      />
    </form>
  ) : (
    <p className="legal__rich-text">
      {I18n.t('transfer.cookie-manager.not-yet-set')}
    </p>
  );
};

CookieManagerSettings.propTypes = {
  savedTrackingSettings: PropTypes.bool,
  notified: PropTypes.bool,
  updateFormState: PropTypes.func.isRequired,
};

export default CookieManagerSettings;
